import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { usePageLoader } from '../../../context/pageLoader';
import { signOut } from '../signOut';
import useIonicToast from '../../../hooks/useIonicToast';
import { useQueryClient } from '@tanstack/react-query';
import { useHistory } from 'react-router';

export default function useSignOut() {
  const { signedAccessToken: authToken, signedRefreshPayload: refreshToken } =
    useSelector((state: RootState) => state.userSession);
  const queryClient = useQueryClient();
  const { setBusy } = usePageLoader();
  const { presentIonToast } = useIonicToast();
  const dispatch = useDispatch();
  const history = useHistory();

  const clearLocalData = () => {
    dispatch({ type: 'auth/logout' });
    queryClient.clear();
  };

  const requestSignOut = async () => {
    if (!authToken || !refreshToken) return;
    setBusy(true);
    try {
      if (!window.navigator.onLine) {
        clearLocalData();
        history.replace('/auth/sign-in');
        return;
      }
      await signOut({ authToken, refreshToken });
      clearLocalData();
      history.replace('/auth/sign-in');
    } catch (error: any) {
      console.error(error.message);
      presentIonToast(error.message, 'error');
    } finally {
      setBusy(false);
    }
  };

  return {
    requestSignOut,
  };
}
